import script from "./RecipeTable.vue?vue&type=script&setup=true&lang=js"
export * from "./RecipeTable.vue?vue&type=script&setup=true&lang=js"

import "./RecipeTable.vue?vue&type=style&index=0&id=77eab53a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77eab53a"]])

export default __exports__